import { useMemo } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { Maybe } from '../../types';
import {
  IntersessionSummary__FollowUpPreVisitSummaryContent,
  IntersessionSummary__IntakePreVisitSummaryContent,
} from './types';

type FocusOfLastSessionData = {
  title: string;
  hasNotes: boolean;
  focusText?: string;
};

export function useFormatFocusOfLastSessionData(
  content:
    | Maybe<IntersessionSummary__IntakePreVisitSummaryContent | IntersessionSummary__FollowUpPreVisitSummaryContent>
    | undefined,
): FocusOfLastSessionData {
  const t = useTranslate();

  return useMemo(() => {
    if (!content || content.__typename === 'IntakePreVisitSummaryContentObject') {
      return {
        title: t('telehealth-core:providerIntersessionSummary.na'),
        hasNotes: false,
      };
    }

    const focusOfLastSection = content.progressNote?.find((note) => note.label === 'Focus of the session');
    if (!focusOfLastSection || !focusOfLastSection?.item) {
      return {
        title: t('telehealth-core:providerIntersessionSummary.noNotesFromLastSession'),
        hasNotes: false,
      };
    }

    const item = focusOfLastSection.item.endsWith('.') ? focusOfLastSection.item : `${focusOfLastSection.item}.`;

    return {
      title: item,
      hasNotes: true,
      focusText: item,
    };
  }, [content, t]);
}
